/* eslint-disable no-alert, no-console */

import axios from 'axios'
import {API_URL, TOKEN} from '../etc/constants'

export const GET_MATERIAL = 'data/GET_MATERIAL'
export const GET_HOME = 'data/GET_HOME'
export const GET_MATERIALS = 'data/GET_MATERIALS'
export const GET_MATERIAUTHEQUE = 'data/GET_MATERIAUTHEQUE'
export const GET_PROJECTS = 'data/GET_PROJECTS'
export const GET_MATERIALS_KINDS = 'data/GET_MATERIALS_KINDS'
export const GET_PROJECTS_AREAS = 'data/GET_PROJECTS_AREAS'
export const GET_ABOUT = 'data/GET_ABOUT'
export const GET_CONTACT = 'data/GET_CONTACT'

export const ABOUT_IMAGES_LOADED = 'data/ABOUT_IMAGES_LOADED'
export const CONTACT_IMAGES_LOADED = 'data/CONTACT_IMAGES_LOADED'
export const MATERIALS_IMAGES_LOADED = 'data/MATERIALS_IMAGES_LOADED'
export const PROJECTS_IMAGES_LOADED = 'data/PROJECTS_IMAGES_LOADED'
export const HOME_VIDEO_READY = 'data/HOME_VIDEO_READY'

const initialState = {
    materials : [],
    home : null,
    material : null,
    materiautheque : null,
    materialsKinds : [],
    projectsAreas : [],
    projects : [],
    about : null,
    contact : null,
    homeVideoReady : false,
    projectsImagesLoaded : false,
    materialsImagesLoaded : false,
    aboutImagesLoaded : false,
    contactImagesLoaded : false,
}

export default (state = initialState, action) => {
	
	switch (action.type) {

        case GET_MATERIAL:
            // console.log('- material ready')
            return{
                ...state,
                material : { ...state.material, [action.payload.name] : action.payload }
            }
       
        case GET_HOME:
            // console.log('- home ready')
            return{
                ...state,
                home : action.payload
            }
        
        // case GET_MATERIAUTHEQUE:
        //     console.log('- material ready')
        //     return{
        //         ...state,
        //         materiautheque : action.payload
        //     }
            
        case GET_MATERIALS :
            // if( action.payload )
            let materials = action.payload.shuffle()
            materials = materials.shuffle()
            // console.log('- materials ready')
            return{
                ...state,
                materials : materials
            }
            
        case GET_PROJECTS :
            console.log(action.payload)
            return{
                ...state,
                projects : action.payload
            }
        
        case GET_MATERIALS_KINDS :
            // console.log('- kinds ready')
            return{
                ...state,
                materialsKinds : action.payload
            }
        
        case GET_PROJECTS_AREAS :
            // console.log('- areas ready')
            return{
                ...state,
                projectsAreas : action.payload
            }

        case GET_ABOUT: 
            // console.log('- about ready')
            return{
                ...state,
                about : action.payload   
            }
        
        case GET_CONTACT: 
            // console.log('- contact ready')
            return{
                ...state,
                contact : action.payload   
            }

        case ABOUT_IMAGES_LOADED :
            return{
                ...state,
                aboutImagesLoaded : true
            }
        
        case CONTACT_IMAGES_LOADED :
            return{
                ...state,
                contactImagesLoaded : true
            }
        
        case MATERIALS_IMAGES_LOADED : 
            return{
                ...state,
                materialsImagesLoaded : true
            }
        
        case PROJECTS_IMAGES_LOADED : 
            return{
                ...state,
                projectsImagesLoaded : true
            }
        
        case HOME_VIDEO_READY : 
            // console.log('- home video ready')
            return{
                ...state,
                homeVideoReady : true
            }

        default:
            return state
    }
}


/*
/*
/*        A C T I O N S
/*
/*
*/

export const getMaterials = () => {
	
	return dispatch => {
        
        
        axios.request({
            method: 'get',
            url: `${API_URL}/collections/get/materials?token=${TOKEN}`
        })
        .then((result) => {
            dispatch({ type:GET_MATERIALS , payload:result.data.entries });
        });

	}

}

export const getProjects = () => {
      
    return dispatch => {
      axios.request({
          method: 'post',
          url: `${API_URL}/collections/get/projects?token=${TOKEN}`,
          data: {
              sort : { date : -1 }
          }
      })
      .then((result) => {
          dispatch({ type:GET_PROJECTS , payload:result.data.entries });
      })
	}
}

export const getMaterial = (slug) => {
	
	return dispatch => {
        
        axios.request({
            method: 'get',
            url: `${API_URL}/collections/get/materials?token=${TOKEN}`,
            data: {
                filter: { slug: { $in: [ slug ] },  },
            }
        })
        .then((result) => {
            dispatch({ type:GET_MATERIAL , payload:result.data.entries.first() });
        });

	}

}

export const getMateriautheque = () => {
    return dispatch => {
        
        axios.get(`${API_URL}/regions/data/materials_library?token=${TOKEN}`)
        .then((result) => {
            dispatch({ type:GET_MATERIAUTHEQUE , payload:result.data });
        });

	}
}

export const getAbout = () => {
    return dispatch => {
        
        axios.get(`${API_URL}/regions/data/about?token=${TOKEN}`)
        .then((result) => {
            dispatch({ type:GET_ABOUT , payload:result.data });
        });

	}
}

export const getContact = () => {
    return dispatch => {
        
        axios.get(`${API_URL}/regions/data/contact?token=${TOKEN}`)
        .then((result) => {
            dispatch({ type:GET_CONTACT , payload:result.data });
        });

	}
}

export const getHome = () => {
    return dispatch => {
        
        axios.get(`${API_URL}/regions/data/home?token=${TOKEN}`)
        .then((result) => {
            dispatch({ type:GET_HOME , payload:result.data });
        });

	}
}

export const getMaterialsKinds = () => {
	
	return dispatch => {
        
        axios.get(`${API_URL}/collections/get/materials_kinds?token=${TOKEN}`)
        .then((result) => {
            dispatch({ type:GET_MATERIALS_KINDS , payload:result.data.entries });
        });

	}

}

export const getProjectsAreas = () => {
	
	return dispatch => {
        
        axios.get(`${API_URL}/collections/get/projects_activity_area?token=${TOKEN}`)
        .then((result) => {
            dispatch({ type:GET_PROJECTS_AREAS , payload:result.data.entries });
        });

	}

}

export const setHomeVideoReady = () => {

    return dispatch => {
        dispatch({ type : HOME_VIDEO_READY })
    }

}

export const setAboutImagesLoaded = () => {
    
    return dispatch => {
        dispatch({ type : ABOUT_IMAGES_LOADED  })
    }

}

export const setContactImagesLoaded = () => {
    
    return dispatch => {
        dispatch({ type : CONTACT_IMAGES_LOADED  })
    }

}

export const setMaterialsImagesLoaded = () => {

    return dispatch => {
        dispatch({ type : MATERIALS_IMAGES_LOADED  })
    }

}

export const setProjectsImagesLoaded = () => {

    return dispatch => {
        dispatch({ type : PROJECTS_IMAGES_LOADED  })
    }

}




// WEBPACK FOOTER //
// ./src/behaviors/data.js